"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridConfig = require("./grid-config");
var _excluded = ["dataTestId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  dataTestId: _propTypes["default"].string
};
var defaultProps = {
  dataTestId: null
};
var StyledComponent = _styledComponents["default"].div.withConfig({
  displayName: "grid-container__StyledComponent",
  componentId: "sc-gx9cn7-0"
})(["display:grid;padding:0 ", ";place-items:center;@media screen and (min-width:", "){padding:0 ", ";}"], _gridConfig.gridConfig.xxs.margin, _gridConfig.gridConfig.m.minWidth, _gridConfig.gridConfig.m.margin);
var GridContainer = forwardRef(function (_ref, ref) {
  var dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledComponent, _extends({
    className: "fuse-responsive-grid__container",
    "data-testid": dataTestId,
    ref: ref
  }, props));
});
GridContainer.propTypes = propTypes;
GridContainer.defaultProps = defaultProps;
GridContainer.displayName = 'GridContainer';
var _default = exports["default"] = GridContainer;